import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("defaultSystem", ["user"]),
  },
  methods: {
    $checkPermission(permission) {
      let role = JSON.parse(this.user.permissions);
      return role.some(item => item === permission);
    }
  }
};
